module.exports = __webpack_public_path__ + "img/xxhg.371d1d6e.png";